/**
 * BlogPost Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { VelocityComponent } from 'velocity-react';

import ImageLoaded from '../../../../containers/ImageLoaded';
import Heading from '../../../atoms/text/Heading';
import { Paragraph, Span } from '../../../atoms/text/Label';

interface IOwnProps {
  data: GQL.IBlogPost;
  index: number;
}

const classes = new BEM('blog-post');

export default class BlogPost extends React.PureComponent<IOwnProps> {

  render() {
    const { data, index } = this.props;

    return (
      <ImageLoaded>
        {({ imageLoaded }) => (
          <a
            href={data.post_url}
            target="_blank"
            {...classes('', { loading: !imageLoaded, ready: imageLoaded })}
          >
            <div
              style={{
                animationDelay: `${.5 * index}s`,
              }}
              {...classes('image') }
            >
              <VelocityComponent animation={imageLoaded ? 'fadeIn' : 'fadeOut'}>
                <img src={data.image_url} alt={`${data.title}`} />
              </VelocityComponent>
            </div>
            <div {...classes('content')}>
              <Heading is="h4" text={data.title} maxTextLength={100} {...classes('title')} />
              <Paragraph size="medium" text={data.excerpt} maxTextLength={140} {...classes('excerpt')} />
              {data.author && <Span size="large" variant="description" {...classes('credit')}>{data.author}</Span>}
            </div>
          </a>
        )}
      </ImageLoaded>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/content/BlogPosts/BlogPost.tsx